<template>
  <div class="d-flex flex-column p-2 border border-secondary-subtle rounded shadow-sm">
    <div v-if="title || buttons || search || close" class="d-flex gap-2 align-items-center mb-2">

      <p v-if="title" class="h4 text-nowrap position-relative px-2 py-1" style="top: 2px">{{ title }}</p>
      <button
          v-for="b in buttons"
          :key="b"
          class="btn btn-sm text-nowrap"
          :class="{[b.class||'btn-primary']:true}"
          @click="$emit('click-button', b)"
      >
        {{ b.button }}
      </button>
      <input v-if="search" v-model="contains" type="text" class="form-control form-control-sm ms-auto" placeholder="Искать">
      <i v-if="close" class="bi bi-x me-2 fs-4" style="cursor: pointer" @click="$emit('click-close')"/>
    </div>

    <table class="table table-hover mb-0">

      <thead v-if="!noHeader">
      <tr>
        <th
            v-for="(fmt,i) in format"
            :key="fmt"
            scope="col"
            class="text-nowrap"
            :style="sort?'cursor: pointer':''"
            @click="onSort(i)"
        >
          {{ fmt[1] || fmt[0] }}
          <i
              v-if="sorted?.col==i"
              class="bi"
              :class="{
                'bi-arrow-up-short': sorted?.asc,
                'bi-arrow-down-short': !sorted?.asc,
              }"
          />

        </th>
      </tr>
      </thead>

      <tbody>
      <tr
          v-for="item in itemsPage" :key="item"
          @click="$emit('click-item', item)"
          style="cursor: pointer"
      >
        <td
            v-for="fmt in format" :key="fmt"
            :class="_rowClass(item)"
            v-html="_formatItem(fmt, item)"
        />
      </tr>
      </tbody>

      <caption v-if="!noHeader">{{ "Всего " + itemsFiltered.length }}</caption>

    </table>

    <simple-table-pag
        v-if="pageSize && (pages > 1 || page > 0)"
        @click-page="page=$event"
        :pages="pages"
        :page="page"
    />
  </div>
</template>

<script>
import SimpleTablePag from "@/components/simple-table/SimpleTablePag";

export default {
  components: {SimpleTablePag},
  props: [
    "items", // todo nullable
    "format",   // table format, [[column_field, ?column_title, ?item=>what_to_display], ...]
    "title",
    "pageSize",
    "buttons",
    "search",
    "sort", // true || { col: N, asc: true }
    "close",
    "noHeader",
    "select", // item => bool | 'rowclass' | { rowclass: true }
    "rowClass", // item => 'rowclass' | { rowclass: true}
  ],
  emits: ["click-item", "click-button", "click-close"],
  data() {
    return {
      page: 0,
      contains: "",
      sorted: null,
    }
  },

  created() {
    if (typeof this.sort === "object")
      this.sorted = this.sort;
  },


  methods: {
    onSort(col) {
      if (!this.sort) return;
      if (this.sorted?.col == col) {
        this.sorted.asc = !this.sorted.asc;
      } else {
        this.sorted = {
          col: col,
          asc: true,
        }
      }
    },

    _formatItem(fmt, item) {
      return (fmt[2] || (i => i[fmt[0]]))(item)

    },

    _rowClass(item) {
      let rowClass = {};

      if (this.rowClass) {
        const res = this.rowClass(item);
        if (res)
          rowClass = {
            ...(typeof res === "string" ? {[res]: true} : res),
            ...rowClass
          }
      }

      if (this.select) {
        let res = this.select(item);
        if (res) {
          if (typeof res === "boolean")
            res = "bg-primary-subtle";
          rowClass = {
            ...(typeof res === "string" ? {[res]: true} : res),
            ...rowClass
          }
        }
      }
      return rowClass;
    },
  },

  watch: {
    contains() {
      this.page = 0;
    },
    sorted: {
      handler() {
        this.page = 0;
      },
      deep: true,
    },
  },

  computed: {
    itemsFiltered() {
      return this.contains ?
          this.items.filter(
              // item => this.fields.map(f => item[f]).join(" ").toLowerCase().includes(this.contains.toLowerCase())
              item => this.format.map(fmt => this._formatItem(fmt, item)).join(" ").toLowerCase().includes(this.contains.toLowerCase())
          )
          :
          this.items;
    },
    itemsSorted() {
      return this.sorted ?
          this.itemsFiltered.toSorted(
              (a, b) => {
                const fmt = this.format[this.sorted.col];
                const va = this._formatItem(fmt, a);
                const vb = this._formatItem(fmt, b);

                if (va > vb) return this.sorted.asc ? 1 : -1;
                if (va < vb) return this.sorted.asc ? -1 : 1;
                return 0;
              }
          )
          :
          this.itemsFiltered;
    },
    itemsPage() {
      return this.pageSize ?
          this.itemsSorted.slice(this.page * this.pageSize, (this.page + 1) * this.pageSize)
          :
          this.itemsSorted;
    },
    pages() {
      return Math.floor((this.itemsFiltered.length - 1) / this.pageSize) + 1;
    },
    fields() {
      return this.format.map(i => i[0]);
    },
  },


}
</script>
